<template>
  <div class="stepOne">
    <div class="checkContainer">
      <div class="checkContainer_top">
      </div>
      <div class="checkContainer_body">
        <div v-for="item in showCateLogue" :key="item.idx">
          <div v-if="item.idx <= currentIdx" class="detailInfoContainer">
            <div :class="{
                  detailSuccess: item.idx < currentIdx,
                  detailWait: item.idx > currentIdx,
                  detailLoading: item.idx == currentIdx,
                }"
                 class="detailicon"></div>
            <div class="detailInfo_title">{{ item.name }}</div>
            <div class="detailInfo_text">
              <template v-if="item.idx < currentIdx">正在进行文件解析</template>
              <template v-if="item.idx == currentIdx">正在进行智能检查，通过文件拆解和语义分析，寻找相似内容，请耐心等待……</template>
              <template v-if="item.idx>currentIdx">目录待进行智能检查</template>
            </div>
          </div>

        </div>
        <div class="modelContainer">
          <div class="checkmodel"></div>
          <div class="checkLine"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "catelogueAnimate",
  data() {
    return {
      // 当前节点的idx
      currentIdx: 0,
      // 定时器
      timer: null,
      hasCateLogue: true,
    }
  },
  created() {
  },
  mounted() {
    if (this.hasCateLogue) {
      this.startAnimation()
    }
  },
  methods: {
    /**
     * 开始动画
     */
    startAnimation() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.currentIdx > this.allCateLogue.length) {
          this.currentIdx = 0
        } else {
          this.currentIdx = this.currentIdx + 1;
        }
      }, 2000)
    },
    cancel() {
      this.$emit('cancel')
    }
  },
  computed: {
    ...mapState('word', ['catelogueData']),
    /**
     * 所有的节点信息  组合在一起
     * @returns {*|*[]}
     */
    allCateLogue() {
      let tempArr = []
      this.$_.each(this.catelogueData, (item) => {
        tempArr = tempArr.concat(item.info)
      })
      tempArr = this.$_.map(tempArr, (item, idx) => {
        return {
          name: item,
          idx: idx
        }
      })
      return tempArr
    },
    /**
     * 用于展示动画的节点信息

     */
    showCateLogue() {
      if (this.allCateLogue.length == 0) {
        this.hasCateLogue = false
        return [{name: "1、招标文件", idx: 0}]
      } else {
        this.hasCateLogue = true
        if (document.body.clientHeight < 700) {
          if (this.currentIdx < 5) {
            let Info = this.allCateLogue.slice(0, 5)
            return Info
          } else {
            let Info = this.allCateLogue.slice(this.currentIdx - 4, this.currentIdx + 1)
            return Info
          }
        } else {
          if (this.currentIdx < 10) {
            let Info = this.allCateLogue.slice(0, 10)
            return Info
          } else {
            let Info = this.allCateLogue.slice(this.currentIdx - 9, this.currentIdx + 1)
            return Info
          }
        }
      }
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
@keyframes turn {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@keyframes checkProcess {
  0% {
    height: 0px;
  }
  50% {
    height: 100%;
  }
  100% {
    height: 0px;
  }
}

.stepOne {
  flex: 1;
  height: 1px;
  width: 1200px;
  background-image: url("~@/assets/image/u138.svg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;

  .checkContainer {
    width: 90%;
    height: 80%;
    background-image: url("~@/assets/image/checkContainer.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 50px auto 0 auto;
    display: flex;
    flex-direction: column;

    .checkContainer_top {
      flex: 16;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .checkContainer_top_text {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
      }
    }

    .checkContainer_body {
      flex: 84;
      padding: 15px 3% 3% 3%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;

      .modelContainer {
        position: absolute;
        top: 0;
        bottom: 3%;
        left: 3%;
        right: 3%;
        box-sizing: border-box;

        .checkmodel {
          width: 100%;
          height: 100%;
          animation: checkProcess 5s linear infinite;
          background: linear-gradient(
                  180deg,
                  rgba(255, 255, 255, 0.2) 21%,
                  rgba(128, 181, 255, 0.4) 79%
          );
        }

        .checkLine {
          width: 100%;
          height: 3px;
          margin: 0 auto 0 auto;
          background-image: url("~@/assets/image/line.png");
          background-repeat: no-repeat;
          background-size: 100%;
        }
      }

      .detailInfoContainer {
        display: flex;
        margin-top: 15px;
        margin-left: 80px;
        margin-right: 30px;
        height: 25px;

        .detailSuccess {
          background-image: url("~@/assets/image/detailSuccess.png");
          background-size: 18px 18px;
          background-repeat: no-repeat;
          background-position: center;
        }

        .detailLoading {
          background-image: url("~@/assets/image/loading.png");
          background-size: 18px 18px;
          background-repeat: no-repeat;
          background-position: center;
          animation: turn 1s linear infinite;
        }

        .detailWait {
          background-image: url("~@/assets/image/detailWait.png");
          background-size: 18px 18px;
          background-repeat: no-repeat;
          background-position: center;
        }

        .detailicon {
          width: 25px;
        }

        .detailInfo_title {
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          line-height: 25px;
          margin-left: 25px;
          max-width: 250px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .detailInfo_text {
          font-weight: 400;
          font-style: normal;
          font-size: 12px;
          color: #7f7f7f;
          line-height: 25px;
          margin-left: 50px;
          max-width: 600px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

    }
  }
}
</style>
